module.exports = __webpack_public_path__ + "img/flexible.14db83b3.svg";